"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconPolicyScan = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "PolicyScan" }, props),
        react_1.default.createElement("title", null, "Policy Scan"),
        react_1.default.createElement("path", { d: "M74.772 60.461l-14.414 14.45 36.708 36.615 14.414-14.451-36.708-36.614z", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M104.223 104.373l-7.135 7.147L60.38 74.898l7.179-7.189", fill: "#000" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M62.312 31.995c-8.374-8.374-21.943-8.374-30.317 0L19.873 19.873c15.069-15.069 39.492-15.069 54.561 0 15.069 15.069 15.069 39.492 0 54.561L62.312 62.312c8.374-8.374 8.374-21.943 0-30.317z", fill: "#D44513" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.995 31.995c-8.374 8.374-8.374 21.943 0 30.317 8.374 8.374 21.943 8.374 30.317 0l12.122 12.122c-15.069 15.069-39.492 15.069-54.561 0-15.069-15.069-15.069-39.492 0-54.561l12.122 12.122z", fill: "#FF6E00" })));
};
exports.default = BrandIconPolicyScan;
